
import * as defaultImport from "@splunk/datasource-utils";
export * from "@splunk/datasource-utils";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
